// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsUserBillingInvoiceApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AdProductsGuestPayInvoicesDto,
  AdproductsGuestPaySupportRequestDto,
  AdproductsZuoraAvailableFilterDto,
  AdproductsZuoraBillingInvoiceDto,
  GuestPayPaymentMethodDto,
  InvoiceDownloadRequestDto,
  InvoiceDownloadResponseDto,
  MaintenanceWindowDto,
  SaveGuestPayInvoiceSelectionRequestDto,
  UserZuoraPaymentMethodDto,
} from '../..';

interface GetErrorMessageForPaymentParams {
  accountId: string;
  invoiceId: string;
  paymentId: string;
}
interface GetGuestPaySessionParams {
  guestPaySessionId: string;
}
interface GetInvoiceParams {
  invoiceNumber: string;
}
interface GetInvoicesByNumberAndAccountParams {
  accountNumber: string;
  guestPayEmail: string;
  invoiceNumber: string;
}
interface GetPaymentMethodDetailsParams {
  guestPaySessionId: string;
}
interface IsGuestPayEligibleParams {
  accountNumber: string;
  invoiceNumber: string;
}

export const AdproductsUserBillingInvoiceApiHandler_downloadInvoices_Path =
  '/api/web/v1/users/billing/invoices/downloadInvoices';

/**
 * Download invoice files
 */
export const AdproductsUserBillingInvoiceApiHandler_downloadInvoices = (
  postData: InvoiceDownloadRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, InvoiceDownloadRequestDto, InvoiceDownloadResponseDto>(
    {
      endpoint: AdproductsUserBillingInvoiceApiHandler_downloadInvoices_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getErrorMessageForPayment_Path =
  '/api/web/v1/users/billing/invoices/getErrorMessageForPayment';

/**
 * Properties corresponding to invoices
 */
export const AdproductsUserBillingInvoiceApiHandler_getErrorMessageForPayment = (
  getParams: GetErrorMessageForPaymentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetErrorMessageForPaymentParams, never, string>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoiceApiHandler_getErrorMessageForPayment_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getGuestPaySession_Path =
  '/api/web/v1/users/guestBilling/invoicePay/getGuestPaySession';

export const AdproductsUserBillingInvoiceApiHandler_getGuestPaySession = (
  getParams: GetGuestPaySessionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetGuestPaySessionParams, never, AdProductsGuestPayInvoicesDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoiceApiHandler_getGuestPaySession_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getInvoice_Path = '/api/web/v1/users/billing/invoices/getInvoice';

/**
 * Get invoices by invoice number
 */
export const AdproductsUserBillingInvoiceApiHandler_getInvoice = (
  getParams: GetInvoiceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetInvoiceParams, never, AdproductsZuoraBillingInvoiceDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoiceApiHandler_getInvoice_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getInvoicesByNumberAndAccount_Path =
  '/api/web/v1/users/guestBilling/invoicePay/getInvoicesByNumberAndAccount';

export const AdproductsUserBillingInvoiceApiHandler_getInvoicesByNumberAndAccount = (
  getParams: GetInvoicesByNumberAndAccountParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetInvoicesByNumberAndAccountParams, never, AdProductsGuestPayInvoicesDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoiceApiHandler_getInvoicesByNumberAndAccount_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getMaintenanceWindow_Path =
  '/api/web/v1/users/billing/invoices/getMaintenanceWindow';

export const AdproductsUserBillingInvoiceApiHandler_getMaintenanceWindow = (client = getClient()) => {
  return httpFrontEndRequest<never, never, MaintenanceWindowDto>(
    {
      endpoint: AdproductsUserBillingInvoiceApiHandler_getMaintenanceWindow_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getPaymentMethodDetails_Path =
  '/api/web/v1/users/guestBilling/invoicePay/getPaymentMethodDetails';

export const AdproductsUserBillingInvoiceApiHandler_getPaymentMethodDetails = (
  getParams: GetPaymentMethodDetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPaymentMethodDetailsParams, never, UserZuoraPaymentMethodDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoiceApiHandler_getPaymentMethodDetails_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_getZuoraBillingFilterOptions_Path =
  '/api/web/v1/users/billing/invoices/getZuoraBillingFilterOptions';

/**
 * Properties corresponding to invoices
 */
export const AdproductsUserBillingInvoiceApiHandler_getZuoraBillingFilterOptions = (client = getClient()) => {
  return httpFrontEndRequest<never, never, AdproductsZuoraAvailableFilterDto>(
    {
      endpoint: AdproductsUserBillingInvoiceApiHandler_getZuoraBillingFilterOptions_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_isGuestPayEligible_Path =
  '/api/web/v1/users/guestBilling/invoicePay/isGuestPayEligible';

export const AdproductsUserBillingInvoiceApiHandler_isGuestPayEligible = (
  getParams: IsGuestPayEligibleParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsGuestPayEligibleParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingInvoiceApiHandler_isGuestPayEligible_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_saveGuestPayInvoiceSelection_Path =
  '/api/web/v1/users/guestBilling/invoicePay/saveGuestPayInvoiceSelection';

export const AdproductsUserBillingInvoiceApiHandler_saveGuestPayInvoiceSelection = (
  postData: SaveGuestPayInvoiceSelectionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SaveGuestPayInvoiceSelectionRequestDto, void>(
    {
      endpoint: AdproductsUserBillingInvoiceApiHandler_saveGuestPayInvoiceSelection_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_sendGuestPaySupportEmail_Path =
  '/api/web/v1/users/guestBilling/invoicePay/sendGuestPaySupportEmail';

export const AdproductsUserBillingInvoiceApiHandler_sendGuestPaySupportEmail = (
  postData: AdproductsGuestPaySupportRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AdproductsGuestPaySupportRequestDto, void>(
    {
      endpoint: AdproductsUserBillingInvoiceApiHandler_sendGuestPaySupportEmail_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingInvoiceApiHandler_updateGuestPayPaymentMethodDetails_Path =
  '/api/web/v1/users/guestBilling/invoicePay/updateGuestPayPaymentMethodDetails';

export const AdproductsUserBillingInvoiceApiHandler_updateGuestPayPaymentMethodDetails = (
  postData: GuestPayPaymentMethodDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GuestPayPaymentMethodDto, void>(
    {
      endpoint: AdproductsUserBillingInvoiceApiHandler_updateGuestPayPaymentMethodDetails_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};
